import { atom } from 'recoil'

export default atom({
  key: 'cursor',
  default: 'grab'
})
